function isLazyModuleImport(value) {
    return 'function' == typeof value && !value.prototype?.metadata && 0 === value.length;
}
async function resolveLazyModuleImport(lazyImport) {
    const result = await lazyImport();
    if (result && 'object' == typeof result && 'default' in result) return result.default;
    return result;
}
export { isLazyModuleImport, resolveLazyModuleImport };
